import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { createId } from '@core/util/file';
import { LawFirmEmployeeType } from '@models/lawFirms';
import { LawFirm } from '@models/lawFirms';
import { CreateStatusType } from '@state/utils/models';

@Component({
	selector: 'app-create-law-firm-employee',
	templateUrl: './create-employee.component.html',
	standalone: false,
})
export class CreateLawFirmEmployeeComponent {
	public _firstName;
	public _lastName;
	public _id;
	public createStatusType = CreateStatusType;
	public role: LawFirmEmployeeType;
	public lawFirm: LawFirm;
	public required = true;
	public label;

	setName(value: string) {
		const _values = value.split(' ');
		this._lastName = _values[0]?.replace(/,/, '');

		if (_values.length > 1) {
			this._firstName = _values.slice(1).join(' ');
		}
	}

	constructor(
		public dialogRef: MatDialogRef<CreateLawFirmEmployeeComponent>,
		// rome-ignore lint/suspicious/noExplicitAny: <explanation>
		@Inject(MAT_DIALOG_DATA) public data: any,
	) {
		this._firstName = data?.firstName;
		this._lastName = data?.lastName;
		this.label = `${data.lawFirm[data.role] ? 'Edit' : 'Add'}`;
		this.role = data.role;
		if (this.role === LawFirmEmployeeType.LAWYER) {
			this._id = data?.lawFirm?.lawyer?.id ?? createId();
		} else if (this.role === LawFirmEmployeeType.CLERK) {
			this._id = data?.lawFirm?.clerk?.id ?? createId();
		}
		this.lawFirm = data.lawFirm;

		if (data.name && !(data?.firstName && data?.lastName)) {
			this.setName(data.name);
		}
	}

	onSubmit(event) {
		this.dialogRef.close({ id: this._id, ...event });
	}
}

export interface CreateOrUpdateLawFirmEmployeeModel {
	name?: string;
	firstName?: string;
	lastName?: string;
	role: LawFirmEmployeeType;
	lawFirm: LawFirm;
}
